// src/components/wellfinder/WellFinderReportButton.jsx
//
// Invokes the wellfinder_report action with the current viewport scope.
// Shares the same backend + action-run lifecycle as the AI on Demand workspace.

import { useState } from 'react';
import { FileText, Loader2, CheckCircle2, AlertCircle } from 'lucide-react';

import { getActionById } from '../../actions/registry.js';
import { fetchWithAuth } from '../../api/fetchWithAuth';

export default function WellFinderReportButton({ mapRef }) {
    const [status, setStatus] = useState('idle');   // 'idle' | 'running' | 'complete' | 'failed'
    const [error, setError] = useState(null);

    async function handleClick() {
        const map = mapRef?.current;
        if (!map) return;

        const b = map.getBounds();
        const bbox = [b.getWest(), b.getSouth(), b.getEast(), b.getNorth()]
            .map((v) => v.toFixed(6))
            .join(',');

        const scope = { kind: 'viewport', bbox };
        const action = getActionById('wellfinder_report');
        if (!action) return;

        setStatus('running');
        setError(null);
        try {
            await action.run({ scope, fetchWithAuth });
            setStatus('complete');
            setTimeout(() => setStatus('idle'), 3000);
        } catch (err) {
            console.error('[WellFinderReport] failed', err);
            setError(String(err?.message ?? err));
            setStatus('failed');
            setTimeout(() => setStatus('idle'), 6000);
        }
    }

    return (
        <div className="flex flex-col gap-1">
            <button
                onClick={handleClick}
                disabled={status === 'running'}
                className="flex items-center justify-center gap-1.5 px-3 py-1.5
                           rounded-md border border-accent-action/40 bg-accent-action/10
                           text-accent-action text-[11px] font-medium
                           hover:bg-accent-action/20 disabled:opacity-40
                           transition"
            >
                {status === 'running'  && <><Loader2 size={11} className="animate-spin" /> Generating…</>}
                {status === 'complete' && <><CheckCircle2 size={11} /> Downloaded</>}
                {status === 'failed'   && <><AlertCircle size={11} /> Failed — retry</>}
                {status === 'idle'     && <><FileText size={11} /> Generate Report</>}
            </button>

            {status === 'failed' && error && (
                <p className="text-[10px] text-red-400/80 leading-relaxed px-1">
                    {error}
                </p>
            )}
        </div>
    );
}